module.exports = __webpack_public_path__ + "static/Aquatheraphy_Pool-464f3bbd5756d5983dbaaeeb002ac2eb.jpg";